import {ReactNode, createContext, useContext, useMemo} from "react";

type ResolvedProcessIdContextValue = {
  processId: number | null;
};

const ResolvedProcessIdContext = createContext<ResolvedProcessIdContextValue>({
  processId: null,
});

type Props = {
  processId: number | null | undefined;
  children: ReactNode;
};

const ResolvedProcessIdProvider = (props: Props) => {
  const {processId, children} = props;

  const value = useMemo<ResolvedProcessIdContextValue>(
    () => ({
      processId: typeof processId === "number" ? processId : null,
    }),
    [processId],
  );

  return (
    <ResolvedProcessIdContext.Provider value={value}>
      {children}
    </ResolvedProcessIdContext.Provider>
  );
};

export const useResolvedProcessId = () => {
  const ctx = useContext(ResolvedProcessIdContext);
  if (!ctx.processId) {
    throw new Error(
      "useResolvedProcessId must be used within ResolvedProcessIdProvider with a valid processId",
    );
  }
  return ctx.processId;
};

export const useResolvedProcessIdOrNull = () => {
  const ctx = useContext(ResolvedProcessIdContext);
  return ctx.processId;
};

export default ResolvedProcessIdProvider;

